import { forwardRef } from "react";

const TextField = forwardRef(({ label, desc, className, ...props }, ref) => {
  return (
    <div className={`awd-textarea-wrapper ${className}`}>
      <textarea
        ref={ref}
        className="awd-textarea"
        id="sampleTextarea"
        {...props}
        placeholder="Description"
      ></textarea>
      <label className="awd-textarea-label-wrapper" htmlFor="sampleTextarea">
        <span className="awd-textarea-label">{label}</span>
      </label>
      {desc && (
        <div className="awd-textarea-desc">
          <span>{desc}</span>
        </div>
      )}
    </div>
  );
});

export default TextField;
